import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-data-policy-google',
  standalone: true,
  imports: [],
  templateUrl: './data-policy-google.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './data-policy-google.component.scss'
})
export class DataPolicyGoogleComponent {

}
